module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.9d9c00f4.mp3";